var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('icon',{attrs:{"name":"close"}})}
var staticRenderFns = []

export { render, staticRenderFns }